var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4761 23.5C44.4761 34.8505 35.3305 44.0625 24.0389 44.0625C12.7473 44.0625 3.60156 34.8505 3.60156 23.5C3.60156 12.1392 12.7473 2.9375 24.0389 2.9375C35.3305 2.9375 44.4761 12.1392 44.4761 23.5Z",
    fill: "#0075FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3955_12008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7355 16.1554C25.7355 15.0777 26.6981 14.6906 27.7757 14.6906C28.8534 14.6906 30.0042 15.0254 30.0042 15.0254L30.6948 10.9241C30.6948 10.9241 29.23 10.4219 25.7355 10.4219C23.5907 10.4219 22.3456 11.238 21.4354 12.4412C20.5774 13.5816 20.546 15.4125 20.546 16.5948V19.2837H17.7734V23.2909H20.546V37.2062H25.7355V23.2909H29.8473L30.1507 19.2837H25.7355V16.1554Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3955_12008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.7843,
    height: 26.7843,
    fill: "white",
    transform: "translate(10.8359 10.4219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bb24604f5a4b0461ac801bbb6f12c96a.svg";
export { ForwardRef as ReactComponent };